import { UT_METHOD_CONFIG } from '@/types/weldNdtTypes'
import type { WeldNdtReportData } from '@/types/weldNdtTypes'
import { generateWeldNdtPDF } from './weldNdtPDFTemplate'

export async function generatePDF(data: WeldNdtReportData): Promise<Blob> {
  return generateWeldNdtPDF(data, UT_METHOD_CONFIG)
}

export const generateUTReport = generatePDF
